import { ToolboxFolderResponseType } from 'src/features/Toolbox/types';
import { MediaApiResponseType } from 'src/types';
import {
  FOLDER_LIST_TOOLBOX,
  ADD_FOLDER_TOOLBOX,
  ADD_FILES_TO_FOLDER_TOOLBOX,
  UPDATE_FOLDER_NAME_TOOLBOX,
  UPDATE_FILE_NAME_TOOLBOX,
  DELETE_FOLDER_TOOLBOX,
  DELETE_FILE_TOOLBOX,
  ADD_FOLDER_HISTORY_TOOLBOX,
  DELETE_LAST_FOLDER_HISTORY_TOOLBOX,
  RESET_FOLDER_HISTORY_TOOLBOX,
} from '../actions/toolboxActions';

type ToolboxFolderActionPayloadType = {
  children?: Array<ToolboxFolderResponseType>;
  id?: string;
  medias?: Array<MediaApiResponseType>;
  model_type?: string;
  name?: string;
  parent?: string;
};

export type ToolboxReducerActionType = {
  type: string;
  payload?: ToolboxFolderActionPayloadType | MediaApiResponseType | string;
};

const defaultState: {
  folder: ToolboxFolderResponseType | null;
  foldersHistory: ToolboxFolderResponseType[];
} = {
  folder: null,
  foldersHistory: [],
};

const toolboxReducer = (
  state = defaultState,
  action: ToolboxReducerActionType
) => {
  switch (action.type) {
    case FOLDER_LIST_TOOLBOX:
      return {
        ...state,
        folder: action.payload,
      };
    case ADD_FOLDER_TOOLBOX:
      return {
        ...state,
        folder: {
          ...state.folder,
          children: state.folder
            ? [action.payload, ...state.folder.children]
            : [action.payload],
        },
      };
    case ADD_FILES_TO_FOLDER_TOOLBOX:
      return {
        ...state,
        folder: {
          ...state.folder,
          medias: state.folder ? [action.payload, ...state.folder.medias] : [],
        },
      };
    case UPDATE_FOLDER_NAME_TOOLBOX:
      const updatedFolder = action.payload as ToolboxFolderActionPayloadType;

      return {
        ...state,
        folder: {
          ...state.folder,
          children: state.folder?.children.map(children => {
            if (children.id === updatedFolder.id)
              return {
                ...children,
                name: updatedFolder.name,
              };

            return children;
          }),
        },
      };
    case UPDATE_FILE_NAME_TOOLBOX:
      const updatedFile = action.payload as ToolboxFolderActionPayloadType;

      return {
        ...state,
        folder: {
          ...state.folder,
          medias: state.folder?.medias.map(media => {
            if (media.id === updatedFile.id)
              return {
                ...media,
                name: updatedFile.name,
              };

            return media;
          }),
        },
      };
    case DELETE_FOLDER_TOOLBOX:
      return {
        ...state,
        folder: {
          ...state.folder,
          children: state.folder?.children.filter(
            folder => folder.id !== action.payload
          ),
        },
      };
    case DELETE_FILE_TOOLBOX:
      return {
        ...state,
        folder: {
          ...state.folder,
          medias: state.folder?.medias.filter(
            media => media.id !== action.payload
          ),
        },
      };
    case ADD_FOLDER_HISTORY_TOOLBOX: {
      const folder = action.payload as ToolboxFolderResponseType;

      if (state.foldersHistory.find(({ id }) => folder.id === id)) return state;

      return {
        ...state,
        foldersHistory: state.foldersHistory
          ? [...state.foldersHistory, folder]
          : [folder],
      };
    }
    case DELETE_LAST_FOLDER_HISTORY_TOOLBOX:
      const foldersHistory = state.foldersHistory.slice(0, -1);

      return {
        ...state,
        foldersHistory,
      };
    case RESET_FOLDER_HISTORY_TOOLBOX:
      return {
        ...state,
        foldersHistory: [],
      };
    default:
      return state;
  }
};

export default toolboxReducer;
